<div style="height: 500px;">
  <div class="ball-container" >
    <div class="ball ball-one"></div>
    <div class="shadow shadow-one"></div>
  </div>
</div>
